import React from 'react';

import styled from 'styled-components';

import Header from 'common/Header';
import { CompanyDataType } from 'types/actors';

const CompanyName = styled.div`
  font-size: 14px;
`;

const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin-right: 10px;
  background: linear-gradient(315deg, #5f5fff, #f05fff 50%, #ff5b98 0%);
`;

type Props = {
  company: CompanyDataType | null;
};

const ActionPlansCompanyHeader = ({ company }: Props) => (
  <div data-test-id="action-plans-company-header">
    <Header
      title="Action Plan"
      breadcrumbs={<CompanyName data-test-id="action-plans-company-header-name">{company?.name || ''}</CompanyName>}
      iconComponent={
        <IconContainer data-test-id="action-plans-company-header-icon">
          <img src="/icons/checklist-black.svg" alt="checklist" height="20px" width="20px" />
        </IconContainer>
      }
    />
  </div>
);

export default ActionPlansCompanyHeader;
